export default "__VITE_ASSET__DsrQw8Kz__"